import React from "react";

interface IProps {
    mainText: string;
    secondaryText: string;
}

export default function LoadingAnimation(props: IProps) {
    return (
        <div className="app-loading-wrapper">
            <div className="loading">
                <div className="lds-ring lds-ring-large">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <h1 className="loading-main-text">{props.mainText}</h1>
                <h3 className="loading-secondary-text">{props.secondaryText}</h3>
            </div>
        </div>
    );
}
